import React from 'react';
import styles from './WatchlistActions.css';

import { WATCHLIST_QUERY } from '../../cards/WatchlistTable/queries';
import { useWatchlistState } from '../../Hooks/useWatchlist';
import GqlQueryWrapper from '../GqlQueryWrapper/GqlQueryWrapper';
import { flattenForCSV } from './utils';
import { downloadCSV } from '../../utils/csv';

const WatchlistExportButton = ({ toggleActionDropdown = () => {} }) => {
    const { name, watchlistFunds: tickers } = useWatchlistState();

    const exportToCSVAndClose = (csvData) => {
        downloadCSV(csvData, name);
        toggleActionDropdown(false);
    };

    return (
        <React.Fragment>
            <GqlQueryWrapper
                query={WATCHLIST_QUERY}
                variables={tickers.length ? { tickers } : {}}
                dataFunc={flattenForCSV}
            >
                {({ data }) => (
                    <button
                        className="export-btn"
                        data-metrics-type="DD"
                        type="button"
                        onClick={() => {
                            exportToCSVAndClose(data);
                        }}
                        onKeyPress={() => {
                            exportToCSVAndClose(data);
                        }}
                    >
                        Export CSV
                    </button>
                )}
            </GqlQueryWrapper>
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

export default WatchlistExportButton;
